import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'exclamation-mark', 'ExclamationMark', [["path",{"d":"M12 19v.01"}],["path",{"d":"M12 15v-10"}]]);